import decode from 'jwt-decode'
import { Config } from '../../Config'
import fetch from 'isomorphic-fetch'
import uuid from 'react-native-uuid'
/// This Service is Designed to Authentication user with token.
/// localStorage change to window.localStorage according to standard JS
export default class AuthenticationService {
  // Initializing important variablescls

  constructor (domain) {
    this.domain = domain || Config.authBaseUrl // API server domain
    this.fetch = this.fetch.bind(this) // React binding stuff
    // this.login = this.login.bind(this)
    this.getProfile = this.getProfile.bind(this)
  }
  /*
    login (username, password) {
      const data = {
        name: 'Nandish',
        date: '03/21/2018',
        age: '27'
      }
      var encodedString = jwt.sign({ username: username, password: password, data: data }, 'super', {
        expiresIn: 5 // expires in 24 hours
      })
      this.setToken(encodedString)
      // encodedString= crypto.createCipher("aes-256-ctr",'super').update(token,"utf-8","hex");
      encodedString = btoa(encodedString)
      return Promise.resolve(encodedString)

      // Get a token from api server using the fetch api
      // return this.fetch(`${this.domain}/login`, {
      //     method: 'POST',
      //     body: JSON.stringify({
      //         username,
      //         password
      //     })
      // }).then(res => {
      //     this.setToken(res.token) // Setting the token in window.localStorage
      //     return Promise.resolve(res);
      // })
    }
  */

  getColdFusionAppUrl (isAdmin) {
    if (isAdmin) {
      return Config.adminColdFusionUrl
    } else {
      return Config.coldFusionUrl
    }
  }

  setUUID (uuid) {
    window.localStorage.setItem('uuid', uuid)
  }

  getUUID () {
    return window.localStorage.getItem('uuid')
  }
  clearUUID () {
    window.localStorage.removeItem('uuid')
  }

  navigate (url, e) {
    let route = window.location.pathname ? ((window.location.pathname.indexOf('/admin') !== -1) || (window.localStorage.getItem('isAdmin') == 'true') ? '/admin' + url : url) : ''
    window.localStorage.removeItem('uuid')
    window.location.href = route
  }

  isMasquerade () {
    return this.getToken() !== this.getIdToken()
  }
  isAdminFeature () {
    return (this.isAdmin() && window.location.pathname.indexOf('/admin') !== -1)
  }

  isAdmin () {
    let path = window.location.pathname
    if (path === '/admin') {
      return true
    } else if (window.localStorage.getItem('isAdmin')) {
      return window.localStorage.getItem('isAdmin') == 'true' /// used '==' to validate value not type, type might be diff
    } else {
      return false
    }
  }

  loggedIn () {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken() // GEtting token from window.localStorage
    return !!token && !this.isTokenExpired(token) // handwaiving here
  }

  isTokenExpired (token) {
    try {
      const decoded = decode(token)
      if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
        return true
      } else { return false }
    } catch (err) {
      return false
    }
  }

  setTokens (idToken, ctxToken, isAdmin) {
    if (idToken) {
      window.localStorage.setItem('id_token', idToken)
    }
    if (ctxToken) {
      window.localStorage.setItem('ctx_token', ctxToken)
    }
    window.localStorage.setItem('isAdmin', isAdmin)
    window.localStorage.setItem('sessionUID', uuid.v4().toUpperCase().replace(/-/g, ''))
  }

  getSessions () {
    return window.localStorage.getItem('sessionUID')
  }

  setToken (idToken, isAdmin) {
    this.setTokens(idToken, idToken, isAdmin)
  }

  setAdmin (isAdmin) {
    window.localStorage.setItem('isAdmin', isAdmin)
  }

  setUserName (userName) {
    if (userName) { window.localStorage.setItem('userName', userName) }
  }
  getUserName () {
    return window.localStorage.getItem('userName')
  }

  getToken () {
    // Retrieves the user token from window.localStorage
    return window.localStorage.getItem('ctx_token')
  }
  getIdToken () {
    // Retrieves the user token from window.localStorage
    return window.localStorage.getItem('id_token')
  }

  logout () {
    // Clear user token and profile data from window.localStorage
    window.localStorage.removeItem('ctx_token')
  }
  clear () {
    // Clear user token and profile data from window.localStorage
    window.localStorage.removeItem('id_token')
    window.localStorage.removeItem('ctx_token')
    window.localStorage.removeItem('isAdmin')
    window.localStorage.removeItem('uuid')
    window.localStorage.removeItem('isDFAVerified')
    window.localStorage.removeItem('loginAttempts')
    window.localStorage.removeItem('loginAttemptsDate')
    window.localStorage.removeItem('DashboardMetric')
    window.localStorage.removeItem('storeListShowCommonLoader')
    window.localStorage.removeItem('selected-menu')
    window.localStorage.removeItem('user_email')
    window.localStorage.removeItem('user_perm')
    window.localStorage.removeItem('ViewingAsOwner')
    window.localStorage.removeItem('error')
    window.localStorage.removeItem('erroInfo')
    window.localStorage.removeItem('sessionUID')
    window.localStorage.removeItem('CompanyUID')
  }
  clearAgreedAccount () {
    // Clear user token and profile data from window.localStorage
    window.localStorage.removeItem('id_token')
    window.localStorage.removeItem('ctx_token')
  }
  logoutMasquerade () {
    // Clear user token and profile data from window.localStorage
    window.localStorage.removeItem('masquerade')
  }

  /* getLoggedInProfile() {
        // Using jwt-decode npm package to decode the token

        return decode(window.localStorage.getItem('id_token'))
    } */
  isLoggedIn () {
    return this.loggedIn()
  }

  isShowHeader (currentRoute) {
    return currentRoute !== '/validateDfaAuth'
  }

  getProfile () {
    // Using jwt-decode npm package to decode the token
    return this.decodeToken(this.getToken())
  }
  getAdminProfile () {
    // Using jwt-decode npm package to decode the token
    return this.decodeToken(this.getIdToken())
  }
  decodeToken (token) {
    if (token) {
      return decode(token)
    } else {
      return {}
    }
  }

  getPermission () {
    var permission = window.localStorage.getItem('user_perm')
    if (permission) {
      let buff = new Buffer(permission, 'base64')
      let text = buff.toString('ascii')
      try {
        return JSON.parse(text)
      } catch (error) {
        return []
      }
    } else {
      return []
    }
  }

  setPermission (data) {
    let buff = new Buffer(JSON.stringify(data))
    let base64data = buff.toString('base64')
    window.localStorage.setItem('user_perm', base64data)
  }

  setUserEmail (email) {
    window.localStorage.setItem('user_email', email)
  }
  getUserEmail () {
    return window.localStorage.getItem('user_email') ? window.localStorage.getItem('user_email') : null
  }
  clearUserEmail () {
    window.localStorage.removeItem('user_email')
  }
  setSelectedMenu (menu) {
    window.localStorage.setItem('selected-menu', menu)
  }
  getSelectedMenu () {
    return window.localStorage.getItem('selected-menu')
  }
  setCompanyUID (CompanyUID) {
    window.localStorage.setItem('CompanyUID', CompanyUID)
  }
  getCompanyUID () {
    return window.localStorage.getItem('CompanyUID') ? window.localStorage.getItem('CompanyUID') : null
  }
  clearCompanyUID () {
    window.localStorage.removeItem('CompanyUID')
  }

  /* getTokenDetails(token) {
        return decode(token)
    } */

  fetch (url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }

    // Setting Authorization header
    // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
    if (this.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.getToken()
    }

    return fetch(url, {
      headers,
      ...options
    })
      .then(this._checkStatus)
      .then(response => response.json())
  }

  _checkStatus (response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
      return response
    } else {
      var error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }
  setViewingAsOwner (ViewingAsOwner) {
    window.localStorage.setItem('ViewingAsOwner', JSON.stringify(ViewingAsOwner))
  }
  getViewingAsOwner () {
    return window.localStorage.getItem('ViewingAsOwner') ? window.localStorage.getItem('ViewingAsOwner') : null
  }
  clearViewingAsOwner () {
    window.localStorage.removeItem('ViewingAsOwner')
  }
}



// WEBPACK FOOTER //
// ./src/components/Security/AuthenticationService.js